// utils/colorUtils.js

export const colorMap = {
  белый: "#FFFFFF", // White
  черный: "#000000",        // Black
  "черный матовый": "#1C1C1C",   // Matte Black (слегка осветлённый чёрный)
  серебристый: "#C0C0C0",       // Silver
  серый: "#808080",          // Gray
  красный: "#FF0000",           // Red
  синий: "#0000FF",         // Blue
  "синий антрацит": "#2F4F4F",   // Anthracite Blue (тёмно-синий, почти серый)
  "слоновая кость": "#FFFFF0",   // Ivory
  зеленый: "#00FF00",
  золотой: "#FFD700",           // Gold
  бежевый: "#F5F5DC",          // Beige  
  коричневый: "#8B4513",
  розовый: "#FFC0CB",
  фиолетовый: "#800080",
  желтый: "#FFFF00",
  "белый матовый": "#F8F8F8", // Matte White (слегка затемнённый белый)
  голубой: "#87CEEB",          // Sky Blue
  графит: "#4B4B4B",           // Graphite (тёмно-серый)
  "серый матовый": "#A9A9A9",    // Dark Gray (матовость — тусклее)
  // Добавляй по мере необходимости
};

/**
 * Возвращает HEX-код цвета по названию.
 * @param {string} colorName - Название цвета на русском.
 * @returns {string} HEX-код цвета или прозрачный, если не найден.
 */
export const getColorCode = (colorName) => {
  return colorMap[colorName?.toLowerCase()] || "transparent";
};

export function isLightColor(color) {
  if (!color) return false;
  const c = color.substring(1);
  const rgb = parseInt(c, 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 180;
}


export function getColorButtonStyles(colorCode, isHovered, isSelected) {
  if (!isHovered || isSelected) return {};

  return {
    backgroundColor: colorCode,
    color: isLightColor(colorCode) ? "black" : "white",
    border: isLightColor(colorCode) ? "1.5px solid #ccc" : undefined,
  };
}

